import styled from 'styled-components'
import DefaultButton from '../Button'

export default styled(DefaultButton).attrs({ type: 'submit' })`
  margin-top: 28px;
  background-color: ${({ theme }) => theme.support.green.base};

  :hover {
    background-color: #069e59;
  }

  @media (max-width: ${({ theme }) => theme.breakpoint.sm.maxWidth}) {
    margin-top: ${({ theme }) => theme.spacing.km10};
  }
`
